<template>
  <div>
    <content-section
      class="form-section mt-12"
    >
      <template #title>
        <h2>Overview</h2>
        <div 
          class="italic text-sm text-grey-700"
        >
          <p>The competitions general settings</p>
        </div>
      </template>

      <div class="-mx-6 flex flex-wrap -mb-8">
        <input-default 
          :input="{
            'key':'competition.title',
            'type':'text',
            'label':'Competition title',
            'instructions':null,
            'attributes':{
              'placeholder':'Your project\'s title',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'2/3'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="competition.title"
          @update:input="input"
        />
        <input-default 
          :input="{
            'key':'competition.published_at',
            'type':'date',
            'label':'Publish date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/3'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.published_at)"
          @update:input="input"
        />

        <h3 class="w-full mx-6 mb-2 text-base">
          Competition Duration
        </h3>

        <input-default 
          :input="{
            'key':'competition.start_date',
            'type':'date',
            'label':'Start date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.start_date)"
          @update:input="input"
        />
        <input-default 
          :input="{
            'key':'competition.end_date',
            'type':'date',
            'label':'End date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.end_date)"
          @update:input="input"
        />

        <h3 class="w-full mx-6 mb-2 text-base">
          Application Phase
        </h3>

        <input-default 
          :input="{
            'key':'competition.application_start_date',
            'type':'date',
            'label':'Publish date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.application_start_date)"
          @update:input="input"
        />
        <input-default 
          :input="{
            'key':'competition.application_end_date',
            'type':'date',
            'label':'End date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.application_end_date)"
          @update:input="input"
        />

        <h3 class="w-full mx-6 mb-2 text-base">
          Contract Phase
        </h3>

        <input-default 
          :input="{
            'key':'competition.contracting_start_date',
            'type':'date',
            'label':'Publish date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.contracting_start_date)"
          @update:input="input"
        />
        <input-default 
          :input="{
            'key':'competition.contracting_end_date',
            'type':'date',
            'label':'End date',
            'instructions':null,
            'attributes':{
              'placeholder':'',
              'default':null,
              'prepend':null,
              'append':null,
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'1/2'
            },
            'validation':{
              'min':dateInputFormat(competition.contracting_start_date),
              'max':dateInputFormat(competition.end_date),
              'limit':false
            }
          }"
          :application-value="dateInputFormat(competition.contracting_end_date)"
          @update:input="input"
        />

        <input-multiline
          :input="{
            'key':'competition.overview',
            'type':'multiline',
            'label':'Overview',
            'instructions':'',
            'attributes':{
              'placeholder':'',
              'default':'',
              'prepend':'',
              'append':'',
              'locked':false,
              'required':true
            },
            'wrapper':{
              'width':'full'
            },
            'validation':{
              'min':false,
              'max':false,
              'limit': 1000
            }
          }"
          :application-value="competition.overview"
          @update:input="input"
        />
        <!-- <component
          :is="`Input${componentLookup[input.type]}`"
          v-for="input in field.sub_fields"
          :key="input.key"
          :review-mode="reviewMode"
          :input="input"
          :parent-field="field.key"
          :application-value="application[field.key][input.key]"
          :error="hasError(field,input)"
          @update:input="updateValue"
          @blur="$emit('application:blur')"
        /> -->
      </div>
    </content-section>
  </div>
</template>

<script>
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
export default {
  name: 'CompetitionEditSettings',
  props: {
    fields: {
      type: Object,
      require: true,
      default: null
    }
  },
  computed: {
    competition() {
      return this.fields.competition
    }
  },
  methods: {
    dateInputFormat(date) {
      return format(parseISO(date), 'yyyy-MM-dd')
    },
    input({key, value}) {
      return this.$emit('update:field', { [key]: value })
    }
  }
}
</script>
